const WORDS = ["Pristine", "Reliable", "Local", "Detail-obsessed", "Friendly", "Spotless", "Trusted"];

export default function Marquee({ dark = false }) {
  const items = [...WORDS, ...WORDS];
  return (
    <div
      data-testid="marquee"
      className={`overflow-hidden border-y py-8 ${dark ? "border-white/10 bg-[var(--ink)] text-white" : "border-[var(--line)] bg-[var(--brand-light)] text-[var(--ink)]"}`}
    >
      <div className="marquee-track">
        {items.map((w, i) => (
          <span key={i} className="mx-8 inline-flex items-center gap-8 font-display text-4xl font-extrabold tracking-tight sm:text-6xl">
            {w}
            <span className="text-[var(--brand)]">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
